import React, { createContext, useContext, useEffect, useState } from 'react';
import { createTheme, isValidTheme, defaultTheme, allThemes, themeNames } from '../themes/theme';

const STORAGE_KEY = 'victorialonde-theme';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(defaultTheme);
  const [theme, setThemeObject] = useState(() => createTheme(defaultTheme));

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && isValidTheme(saved)) {
      setCurrentTheme(saved);
      setThemeObject(createTheme(saved));
    }
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute('data-theme', currentTheme);
    document.body.style.backgroundColor = theme.colors.background;
    document.body.style.color = theme.colors.text;
  }, [currentTheme, theme]);

  const setTheme = (name) => {
    if (!isValidTheme(name)) return;
    setCurrentTheme(name);
    setThemeObject(createTheme(name));
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, name);
    }
  };

  const value = {
    currentTheme,
    availableThemes: allThemes,
    themeNames,
    setTheme,
    colors: theme.colors,
    fonts: theme.fonts,
    spacing: theme.spacing,
    borderRadius: theme.borderRadius,
    shadows: theme.shadows,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};
